var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3955 18V9.78996H13.1502L13.5635 6.58941H10.3955V4.54632C10.3955 3.61998 10.6517 2.98869 11.9816 2.98869L13.675 2.98799V0.125307C13.3821 0.0872508 12.3769 0 11.2069 0C8.76376 0 7.09114 1.49127 7.09114 4.22934V6.58941H4.32812V9.78996H7.09114V18H10.3955Z",
    fill: "#18181B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.91ec214e4ff741ef43c2b421354dbb23.svg";
export { ForwardRef as ReactComponent };